import { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '@/components/Loading/Loading';
import i18n from '@/settings/i18n';
import ErrorState from './ErrorState';

const t = i18n.init('business');

/**
 * The EXEMPTAX certificate form for the signed-in customer, in an iframe.
 * Its URL is built server-side (company id from the API key, customer from
 * the session), so nothing secret reaches the page.
 */
const ExemptaxForm = () => {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    axios
      .get<{ url: string }>('/api/business/exemptax-form')
      .then(({ data }) => {
        if (!cancelled) {
          setUrl(data.url);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setFailed(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) {
    return <ErrorState />;
  }

  return (
    <div className="relative min-h-[560px]">
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Loading />
        </div>
      )}
      {url && (
        <iframe
          src={url}
          title={t`Submit your exemption certificate`}
          onLoad={() => setLoaded(true)}
          className="h-[560px] w-full rounded-md border-0"
          allow="clipboard-write"
        />
      )}
    </div>
  );
};

export default ExemptaxForm;
